// Synchronise les selects de variante des cartes produit avec le formulaire quick add.
// Delegation sur document : les cartes re-rendues par les filtres / le tri
// (Section Rendering API, innerHTML) restent fonctionnelles.
(function () {
    function syncCard(cardWrapper) {
        if (!cardWrapper) return;

        const variantSelector = cardWrapper.querySelector('.card__content-hidden-variant');
        const productForm = cardWrapper.querySelector('product-form');
        if (!variantSelector || !productForm) return;

        const variantInput = productForm.querySelector('.product-variant-id');
        const submitButton = productForm.querySelector('.quick-add__submit');
        if (!variantInput || !submitButton) return;

        const optionValues = ['option-1', 'option-2', 'option-3'].map(function (optionClass) {
            const select = cardWrapper.querySelector('.card__content-option.' + optionClass);
            return select ? select.value : '';
        });

        const match = Array.prototype.find.call(variantSelector.options, function (option) {
            return (
                option.getAttribute('data-option-1') == optionValues[0] &&
                option.getAttribute('data-option-2') == optionValues[1] &&
                option.getAttribute('data-option-3') == optionValues[2]
            );
        });

        // Combinaison inexistante : on garde la variante courante et on bloque l'ajout.
        const available = match ? match.getAttribute('data-available') === 'true' : false;

        if (match) {
            variantSelector.value = match.value;
            variantInput.value = match.value;
        }

        variantInput.disabled = !available;
        submitButton.disabled = !available;
        // product-form.js pose aria-disabled sur erreur d'ajout : on repart d'un etat propre.
        submitButton.setAttribute('aria-disabled', String(!available));

        const availableMessage = submitButton.querySelector('.available-message');
        const soldOutMessage = submitButton.querySelector('.sold-out-message');
        if (availableMessage) availableMessage.classList.toggle('hidden', !available);
        if (soldOutMessage) soldOutMessage.classList.toggle('hidden', available);
    }

    document.addEventListener('change', function (event) {
        const select = event.target.closest('.card__content-variants__container .card__content-option');
        if (!select) return;
        syncCard(select.closest('.card-wrapper'));
    });
})();
